import React from 'react';
import { Stack, Tooltip } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { OnePButtonV2Props } from './types';
import Icon from '../Icon';
import { UserAccessControlData } from '../../../utils/accessControl';

const OnePButtonV2: React.FC<OnePButtonV2Props> = (props) => {
  const { accessKey, text = false, ...rest } = props;
  const accessData = UserAccessControlData.get(accessKey);

  return (
    <>
      {accessData ? (
        <Tooltip title={"You don't have access"} placement='top'>
          <Stack sx={rest?.sx} className={rest?.className}>
            <LoadingButton
              {...rest}
              disabled
              startIcon={<Icon icon='ri-git-repository-private-fill' />}
              variant={props.variant || 'contained'}
            >
              {text}
            </LoadingButton>
          </Stack>
        </Tooltip>
      ) : (
        <Stack sx={rest?.sx} className={rest?.className}>
          <LoadingButton {...rest} variant={props.variant || 'contained'}>
            {text}
          </LoadingButton>
        </Stack>
      )}
    </>
  );
};

OnePButtonV2.displayName = 'OnePButtonV2';

export default OnePButtonV2;
